import { render } from "./WorksDelete.vue?vue&type=template&id=1f5f1b54&lang=pug"
import script from "./WorksDelete.vue?vue&type=script&lang=js"
export * from "./WorksDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__